









import { Component, Vue, Watch, Provide, Prop } from "vue-property-decorator";
@Component({
    name: "MaskVue"
})
export default class Mask extends Vue {
    // @Provide() public isMask!: boolean; // 遮罩层
    // 关闭遮罩
    public hideMaskVue(val: any) {
        this.$emit("hideMaskVue", {
            hidden: false
        });
    }
}
